import { Inbox } from "lucide-react";

export default function EmptyState({ title = "Nothing here yet", description, icon: Icon = Inbox, action, testid = "empty-state" }) {
  return (
    <div data-testid={testid} className="flex flex-col items-center justify-center text-center py-16 px-6">
      <div className="grid place-items-center h-14 w-14 rounded-2xl bg-slate-100 text-slate-400 mb-4">
        <Icon className="h-7 w-7" />
      </div>
      <h3 className="text-base font-semibold text-slate-800">{title}</h3>
      {description && <p className="mt-1 text-sm text-slate-500 max-w-sm">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
